
import Catalogo from "@/mixins/catalogo";
import RULES from "@/mixins/rules";
import {mapGetters} from "vuex";
import { solicitudArrendamiento } from "@/models/solicitudArrendamiento";
import EstablecimientoService from '@/services/EstablecimientoService';
import SolicitudArrendamientoService from '@/services/SolicitudArrendamientoService';

export default Catalogo.extend({
    name: "FormsolicitudArrendamiento",
    mixins: [RULES],
    data() {
        return {
            mercados: [],
            formdata: new solicitudArrendamiento(),
            showInputSolid: false,
            showInputAlta: false,
            documento: Document || null,
            dialogPdfView:false,
            establecimientos:[],
            giros:[],
        };
    },
    computed: {
        ...mapGetters({
            usuario: "usuario",
            id: "id",
            contribuyente: "contribuyente",
            mini: "sidebar",
        }),
    },
    methods: {
        async getLocacion() {
            let { data } = await SolicitudArrendamientoService.getLocacion(this.contribuyente.id);
            this.establecimientos = data
        },
        async getGiro() {
            let { data } = await SolicitudArrendamientoService.getGiro();
            this.giros = data
        },
        async viewpdf(id: any,titulo: any) {
      const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

      let file = new Blob([response.data],{type: response.headers['content-type']});
      const url = window.URL.createObjectURL(file);
      this.documento = {
                    //@ts-ignore
                    title: titulo,
                    url: url,
                    mime: response.headers['content-type']
                }
              this.dialogPdfView=true;
      //window.open(url, '_blank', 'noreferrer');
    },
        async getData() {
            if(this.formdata.solicitud_id>0){
                this.showInputSolid = false;
            }
            if(this.formdata.alta_sat_id>0){
                this.showInputAlta = false;
            }
            this.getLocacion();
            this.getGiro();
            this.formdata.contribuyente_id = this.contribuyente.id;
            
        },
        setDocument(e: any, type: number) {
            const fileReader = new FileReader();
            fileReader.addEventListener("load", () => {
                var file = fileReader.result;
                if (type == 1)
                //@ts-ignore
                this.formdata.docSolicitud = file + "";
                if (type == 2)
                //@ts-ignore
                this.formdata.docAltaSat = file + "";
        });
        if (e != null)
        fileReader.readAsDataURL(e);
        },
        cancelChangeFile(file: any) {
      if (file == 1)
        this.showInputSolid = false;

        if (file == 2)
        this.showInputAlta = false;
    },
    changeFile(file: any) {
        if (file == 1)
        this.showInputSolid = true;

        if (file == 2)
        this.showInputAlta = true;
    },
    },
    watch: {
    dialog(val) {
      if(this.dialog) {
        this.getData();
      }
    }
  },
    mounted() {
        this.getData();
    },
});
